import { Alert } from "antd";
import React from "react";

export const AlertBadBrowser = () => {
	return (
		<Alert
			message={
				<b>
					¡Hay algunas funcionalidades desactivadas! Estamos
					trabajando en ello...
				</b>
			}
			description={
				<p>
					Estas usando <b>Internet Explorer</b>, lamentablementemente
					no es totalmente compatible con esta versión de ZeroQ. Para
					una experiencia óptima con ZeroQ, recomendamos usar{" "}
					<b>Google Chrome</b> o <b>Mozilla Firefox</b>.{" "}
					<a href="https://browser-update.org/es/update.html">
						Actualiza tu navegador aquí.
					</a>
				</p>
			}
			type="warning"
			showIcon
		/>
	);
};
